// extracted by mini-css-extract-plugin
export default {"container":"order-details_container__AJWKl","image":"order-details_image__YEti2","number":"order-details_number__0SOQq"};